export const sidebarPinnedStorageKey = "joinmc-sidebar-pinned"; // 侧边栏固定状态缓存 key，退出登录时也要保留。

export const getSidebarPinnedStorage = () => {
  // 固定状态默认取本地缓存；没有缓存时返回 false。
  return localStorage.getItem(sidebarPinnedStorageKey) === "true" || false;
};

export const setSidebarPinnedStorage = (value) => {
  // 固定状态写入本地缓存，刷新和重新登录后沿用用户选择。
  localStorage.setItem(sidebarPinnedStorageKey, String(Boolean(value)));
};

export const clearLocalStorageKeepSidebarPinned = () => {
  // 清理登录态缓存时保留侧边栏固定状态，避免退出登录后丢失布局偏好。
  const sidebarPinnedValue = localStorage.getItem(sidebarPinnedStorageKey);
  localStorage.clear();
  if (sidebarPinnedValue !== null) {
    localStorage.setItem(sidebarPinnedStorageKey, sidebarPinnedValue);
  }
};
